module.exports = __webpack_public_path__ + "img/robot.a92d70c7.png";